import styled from 'styled-components'

export const StyledDatePickerLabelWrapper = styled.div`
    margin-bottom: 10px;
`

export const StyledDatePickerLabel = styled.div`
    margin-bottom: 10px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.5px;
    color: ${({ theme }) => theme.greyishBrown};
`

export const StyledDatePickerContainer = styled.div`
    width: 100%;
    opacity: ${({ active }) => active ? 1 : 0.5};
    transition: opacity 0.3s;
    .react-datepicker-wrapper {
        width: 100%;
    }

    .react-datepicker__input-container{
        width: 100%;
    }

`

export const StyledDatePickerInput = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 14px 14px;
    border: 2px solid ${({ theme }) => theme.veryLightPink};
    border-radius: 6px;
    
    input {
        font-size: 16px;
        font-weight: ${({ theme }) => theme.fontWeight.bold};
        color: ${({ theme }) => theme.greyishBrown};
        border: none;
        
    }
`

export const StyledDatePickerDate = styled.span`
`;